module.exports = __webpack_public_path__ + "img/astronaut.56f57325.png";